import { flashNews } from "@/mocks/gossip";

export default function FlashTicker() {
  const loop = [...flashNews, ...flashNews];

  return (
    <section aria-label="今日热瓜速览" className="w-full bg-accent-100 border-y border-accent-200">
      <div className="w-full flex items-stretch">
        <div className="shrink-0 flex items-center gap-2 px-4 md:px-8 py-3.5 bg-accent-500 text-foreground-950">
          <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
          <span className="text-sm font-semibold font-label whitespace-nowrap">今日热瓜</span>
        </div>
        <div className="flex-1 overflow-hidden flex items-center">
          <div className="flex items-center gap-10 animate-marquee whitespace-nowrap pl-6">
            {loop.map((news, index) => (
              <span key={`${news}-${index}`} className="text-sm text-foreground-800 flex items-center gap-2.5">
                <i className="ri-fire-line text-primary-600" aria-hidden="true"></i>
                {news}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}